import { Tab } from "@renderbus/ui";
import { PageContainer } from "@/components/page-container";
import { MemberRechargeRecord } from "@/pages/payment/view/member-recharge-record";
import { CouponRechargeRecord } from "@/pages/payment/view/coupon-recharge-record";
import { NormalRechargeRecord } from "@/pages/payment/view/normal-recharge-record";
import { FreeCouponTransferRecord } from "@/pages/payment/view/free-coupon-transfer-record";
import { useGlobalStore } from "@/store/GlobalStore";
import { useTranslation } from "react-i18next";
import {
  PaymentStoreContainerProvider,
  usePaymentStore,
} from "./store/payment-store";
import { RechargeRecordTabType } from "./constants";
import { DesktopRechargeRecord } from "./view/desktop-recharge-record";

export function PaymentView() {
  const { isPictureUser, userInfo } = useGlobalStore();
  const { setActiveTabKey, activeTabKey } = usePaymentStore();

  const { t } = useTranslation("center");
  const currentTabsList = [
    {
      label: t("recharge_record_tab_first"),
      children: <NormalRechargeRecord />,
      key: RechargeRecordTabType.Normal,
    },
    {
      label: t("recharge_record_tab_second"),
      children: <CouponRechargeRecord />,
      key: RechargeRecordTabType.Coupon,
    },
  ];
  if (isPictureUser) {
    currentTabsList.push(
      {
        label: t("recharge_record_tab_third"),
        children: <FreeCouponTransferRecord />,
        key: RechargeRecordTabType.FreeCoupon,
      },
      {
        label: t("recharge_record_tab_four"),
        children: <MemberRechargeRecord />,
        key: RechargeRecordTabType.Member,
      }
    );
  }
  if (userInfo?.enableRemoteDesktop) {
    currentTabsList.push({
      label: t("recharge_record_tab_desktop"),
      children: <DesktopRechargeRecord />,
      key: RechargeRecordTabType.Desktop,
    });
  }
  return (
    <PageContainer>
      <Tab
        tabsList={currentTabsList}
        activeKey={activeTabKey}
        onChange={(key) => setActiveTabKey(key as RechargeRecordTabType)}
      />
    </PageContainer>
  );
}

export function Payment() {
  return (
    <PaymentStoreContainerProvider>
      <PaymentView />
    </PaymentStoreContainerProvider>
  );
}
